// extracted by css-extract-rspack-plugin
export default {"withImage":"ContentfulCtaBanner-module__withImage__ZAF_cww"};